import {withRouter} from "react-router-dom";
import {AlertProvider} from "./core/contexts/alertContext";
import useAuth from "./core/hooks/useAuth";
import {fetchPromises} from "./core/utils/fetchPromises";
import {UserProvider} from "./core/contexts/userContext";
import MainPage from "./components/MainPage";

function MarketApp({user}) {
    const {login} = useAuth();

    return (
        <UserProvider user={user} login={login}>
            <AlertProvider>
                <MainPage user={user} />
            </AlertProvider>
        </UserProvider>
    );
}

export default withRouter(
        fetchPromises({
        user: () => ({ name: 'getLoggedUser' })
    })(MarketApp)
);
